import { render, staticRenderFns } from "./StopageViloationReport.vue?vue&type=template&id=b4148e7a&"
import script from "./StopageViloationReport.vue?vue&type=script&lang=js&"
export * from "./StopageViloationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports